
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TextArea = (function () {

    function TextArea () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.input = null;
        this.value = "";

        var baseElement = null;

        this.createElement = function () {

            if (!baseElement) {
                const wrapper = document.createElement('div');
                this.input = document.createElement('textarea');
                this.rootEl.className += ' TextArea';
                this.input.autocomplete = 'off';

                baseElement = this.input;

                if (this.maxSize) {
                    this.input.maxLength = this.maxSize;
                }
                wrapper.appendChild(this.input);
                this.rootEl.appendChild(wrapper);
            }

        };

        this.getValue = function () {
            if (this.input) {
                this.value = this.input.value;
            }
            return this.value;
        };

        this.setValue = function (value) {
            if (value || value === '' || value === 0) {
                this.value = value;
            }

            this.setInputValue();
        };

        this.setInputValue = function () {

            if (this.input) {
                this.input.value = new Monet.Format.TEXT(this.value).getValue();
            }
        };

        this.render = function () {

            this.createElement();
            this.setInputValue();
            return this.rootEl;

        };

        this.setPlaceHolder = function (text) {

            if (this.input) {
                this.input.placeholder = text;
            } else {
                var error = new Monet.Exception.ReturnError(
                    this, 'Monet.UI.Fields.TextArea: setPlaceHolder: this.input is null'
                );

                error.console();
            }

        };

    }

    return TextArea;

}());